import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import Button from '../buttons/Button'

const NavItem = styled.li`
  list-style: none;
  text-align: left;
  margin-top: -1px;
  padding: 0rem 1rem;
  border-bottom: 1px solid #F8F8F8;
  background: #fff;

  &:last-child, &:first-child {
    border: none;
    padding: 0.4rem 1rem;
  }

  a {
    display: block;
  }

  @media (min-width: 800px) {
    text-align: center;
  }
`

const DropdownNavClass = css`  
  @media (min-width: 800px) {
    pointer-events: none;
    transition: .2s ease-out;
    opacity: 0;
    box-shadow: 0 1px 4px rgba(53,57,71,.3);
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 300px;
    right: -50px;
    top: 3.3rem;
  }
`

const Chevron = styled.div`
  position: absolute;
  right: 15px;
  &.flipped {
    -webkit-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -o-transform: rotate(180deg);
    -ms-transform: rotate(180deg);
    transform: rotate(180deg);
  }
`

const IconClass = css`
  color: black;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  &:hover, &:focus {
    .${DropdownNavClass} {
      pointer-events: all;
      opacity: 1;
    }
  }
`

const SubContainer = styled.div``

class MobileDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggled: false
    }
  }

  toggle() {
    if (this.props.nav.links) {
      this.setState({ toggled: !this.state.toggled })
    }
  }
  
  renderLinks(links) {
    return (
      <SubContainer>
        {links.map((link, idx) => (
          <NavItem key={idx}>
            <Button
              anchor
              navLink
              to={link.to}
              external={link.external}
              icon="arrow_right_alt"
              onClick={() => (this.props.onNavigate && this.props.onNavigate()) }
            >{link.label}</Button>
          </NavItem>
        ))}
      </SubContainer>
    )
  }

  render() {
    const {
      label,
      links
    } = this.props.nav
    return (
      <Wrapper onClick={() => this.toggle()}>
        <Button anchor navLink to={`#`} icon={links.length}>
          {label}
          {
            links ? 
            (<Chevron className={this.state.toggled ? 'flipped': ''}>
              <i className={`${IconClass} material-icons`}>expand_more</i>
            </Chevron>)
            : null
          }
        </Button>
        <nav className={DropdownNavClass}>
          {
            this.state.toggled ? 
            this.renderLinks(links)
            : null
          }
        </nav>
      </Wrapper>
    );
  }
}
 
export default MobileDropdown;


// WEBPACK FOOTER //
// ./src/components/header/MobileDropdown.js